import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/joy";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getFetch } from "../../../../../../fetch/fetch";
import { C, toastOptions, formatSigned, balanceStyle } from "./giftcashutil";
import GiftCashChargeModal from "./giftcashchargemodal";
import GiftCashHistoryModal from "./giftcashhistorymodal";

/**
 * 기프티콘 캐쉬 관리표 — 네이버 리뷰 작성자 표 아래 오른쪽 카드
 * 지점 9행 잔액(음수 허용) + 내역/늘리기 + 선물하기 for Biz 사이트 실제 잔액
 * props: refreshKey (바뀌면 잔액 다시 조회 — 지급하기 발송 후 부모가 올림)
 */

const GiftCashCard: React.FC<any> = (props) => {

    const [branches, setBranches] = useState<any[]>([]);
    const [kakaoBalance, setKakaoBalance] = useState<number | null>(null);
    const [kakaoLoading, setKakaoLoading] = useState<boolean>(false);
    const [chargeTarget, setChargeTarget] = useState<any>(null);
    const [historyOpen, setHistoryOpen] = useState<boolean>(false);
    const [historyTarget, setHistoryTarget] = useState<any>(null);

    const fetchSummary = async () => {
        try {
            const result: any = await getFetch("/dashboard/reviewEvent/cash/summary");
            if (result.message === "success" && Array.isArray(result.data)) {
                setBranches(result.data);
            } else {
                console.log(result);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchKakaoBalance = async () => {
        try {
            setKakaoLoading(true);
            const result: any = await getFetch("/dashboard/reviewEvent/cash/kakaoBalance");
            if (result.message === "success" && result.data) {
                setKakaoBalance(+result.data.total_cash);
            } else {
                console.log(result);
                toast.error("선물하기 사이트 잔액을 불러오지 못했습니다", toastOptions);
            }
        } catch (e) {
            console.log(e);
            toast.error("선물하기 사이트 잔액을 불러오지 못했습니다", toastOptions);
        } finally {
            setKakaoLoading(false);
        }
    };

    useEffect(() => {
        fetchSummary();
    }, [props.refreshKey]);

    useEffect(() => {
        fetchKakaoBalance();
    }, [props.refreshKey]);

    const openHistory = (branch: any) => {
        setHistoryTarget(branch);
        setHistoryOpen(true);
    };

    const totalBalance = branches.reduce((sum: number, b: any) => sum + (+b.balance || 0), 0);

    const smallButton: React.CSSProperties = { height: 30, padding: "0 10px", border: `1px solid ${C.border}`, background: "#FFFFFF", borderRadius: 6, fontSize: 12, color: C.text, fontFamily: "inherit", cursor: "pointer" };
    const primaryButton: React.CSSProperties = { height: 30, padding: "0 10px", border: 0, background: C.blue, borderRadius: 6, fontSize: 12, fontWeight: 500, color: "#FFFFFF", fontFamily: "inherit", cursor: "pointer" };

    return (
        <div style={{ marginLeft: "auto", marginTop: 16, width: 400, maxWidth: "100%", background: "#FFFFFF", border: `1px solid ${C.border}`, borderRadius: 8, display: "flex", flexDirection: "column", overflow: "hidden", color: C.text }}>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", borderBottom: `1px solid ${C.line}` }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={C.blue} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="7" width="18" height="12" rx="2"></rect><path d="M3 11h18"></path><path d="M7 15h3"></path></svg>
                    <div style={{ fontSize: 15, fontWeight: 700 }}>기프티콘 캐쉬 관리표</div>
                </div>
                <button type="button" aria-label="내역 전체 보기" title="내역 전체 보기" onClick={() => openHistory(null)} style={{ width: 32, height: 32, border: 0, background: "transparent", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
                    <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.gray} strokeWidth="2" strokeLinecap="round"><path d="M4 6h16M4 12h16M4 18h10"></path></svg>
                </button>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 16px", background: C.grayBg, borderBottom: `1px solid ${C.line}`, fontSize: 12, color: C.gray }}>
                <span>지점</span>
                <span style={{ display: "flex" }}>
                    <span style={{ width: 96, textAlign: "right" }}>잔액</span>
                    <span style={{ width: 128, textAlign: "right", paddingRight: 2 }}>관리</span>
                </span>
            </div>

            <div style={{ display: "flex", flexDirection: "column" }}>
                {branches.map((b: any, index: number) => (
                    <div key={b.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 46, padding: "0 16px", borderBottom: index === branches.length - 1 ? "none" : `1px solid ${C.rowLine}`, boxSizing: "border-box" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 14, fontWeight: 500 }}>
                            {b.label}
                            {b.sub && <span style={{ fontSize: 11, color: C.gray, fontWeight: 400 }}>{b.sub}</span>}
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: 96, textAlign: "right", fontSize: 14, fontVariantNumeric: "tabular-nums", ...balanceStyle(+b.balance) }}>{formatSigned(+b.balance)}원</div>
                            <div style={{ width: 128, display: "flex", justifyContent: "flex-end", gap: 6 }}>
                                <button type="button" onClick={() => openHistory(b)} style={smallButton}>내역</button>
                                <button type="button" onClick={() => setChargeTarget(b)} style={primaryButton}>+ 늘리기</button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 46, padding: "0 16px", borderTop: `1px solid ${C.line}`, background: C.grayBg, boxSizing: "border-box" }}>
                <div style={{ fontSize: 14, fontWeight: 700 }}>선물하기 사이트 잔액</div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ width: 96, textAlign: "right", fontSize: 14, fontVariantNumeric: "tabular-nums", fontWeight: 700, color: C.text }}>
                        {kakaoBalance === null ? "-" : `${formatSigned(kakaoBalance)}원`}
                    </div>
                    <div style={{ width: 128, display: "flex", justifyContent: "flex-end" }}>
                        <button type="button" aria-label="잔액 다시 조회" title="잔액 다시 조회" disabled={kakaoLoading} onClick={fetchKakaoBalance} style={{ width: 30, height: 30, border: `1px solid ${C.border}`, background: "#FFFFFF", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", cursor: kakaoLoading ? "default" : "pointer" }}>
                            {kakaoLoading ?
                                <CircularProgress size="sm" sx={{ "--CircularProgress-size": "14px", "--CircularProgress-trackThickness": "2px", "--CircularProgress-progressThickness": "2px" }} />
                                :
                                <svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={C.gray} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 12a8 8 0 1 1-2.3-5.7"></path><path d="M20 4v5h-5"></path></svg>
                            }
                        </button>
                    </div>
                </div>
            </div>

            <GiftCashChargeModal
                open={!!chargeTarget}
                branch={chargeTarget}
                onClose={() => setChargeTarget(null)}
                onSaved={fetchSummary}
            />

            <GiftCashHistoryModal
                open={historyOpen}
                branch={historyTarget}
                totalBalance={totalBalance}
                onClose={() => setHistoryOpen(false)}
            />
        </div>
    );
};

export default GiftCashCard;
